import { Card, Link, Paper, TextField, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Loading from '../../components/Loading';
import { Stack } from '@mui/system';
import { useGetSalesRepContractsQuery, useGetSalesRepDiscountsQuery, useGetSalesRepQuery, useUpdateSalesRepMutation } from '../../features/model/salesrepSlice';
import { AddContractCard, ContractCard } from './ContractView';
import { SalesRepOrdersListView } from '../../components/OrdersListView';
import { useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import { SalesRepFindersListView } from './SalesRepFindersListView';
import { DiscountCard } from './DiscountView';

dayjs.extend(utc);
dayjs.extend(isBetween)

const ViewContractCard = ({object}) => {
    return <Stack sx={{margin: 2}} direction={"column"}>
            <Typography variant='p'>
                Valid {dayjs.utc(object.startdate).local().format("MM/DD/YYYY")} - {dayjs.utc(object.enddate).local().format("MM/DD/YYYY")}
            </Typography>
            <Typography variant='p'>
                Commission: {object.commission} %
            </Typography>
        </Stack>;
}

const DistributorCommissionsView = () => {
    let params = useParams();
    const user = useSelector(state => state.auth.user)

    const {data: object, error, isLoading } = useGetSalesRepQuery(user.rep_id)
    const {data: discounts, error: discountsError, isLoading: isLoadingDiscounts} = useGetSalesRepDiscountsQuery(user.rep_id)
    const {data: contracts, error: contractsError, isLoading: isLoadingContracts} = useGetSalesRepContractsQuery(user.rep_id)

    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateSalesRepMutation();

    if(!user.rep_id) {
        return <Navigate to="/salesreps" />
    }

    if (isLoading || isUpdating || isLoadingDiscounts || isLoadingContracts) {
      return <Loading />;
    }
    if (error || discountsError || contractsError) {
      return <div>Error: {error.error}</div>
    }

    var discountObjects = []
    if (discounts) {
        discountObjects = discounts.objects;
    }
    var contractObjects = []
    var contract = <Typography variant='p'>No active contract</Typography>
    if (contracts) {
        contractObjects = contracts.objects.slice().filter((c) => dayjs().isBetween(dayjs.utc(c.startdate).local(), dayjs.utc(c.enddate).local(), null, "[]")).sort((a, b) => a.commission > b.commission);
        if(contractObjects.length > 0) {
            let bestContract = contractObjects[0]
            contract = <ViewContractCard key={bestContract.id} object={bestContract} />
        }
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <Paper>
            <Card>
                <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant='h2'>{object.name}</Typography>
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Customer codes</Typography>
                {
                    discountObjects.map((discount, i) => <DiscountCard key={discount.id} discount={discount} admin={false} />)
                }
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Current contract</Typography>
                    {contract}
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <SalesRepOrdersListView contracts={contractObjects} salesrep={object} discounts={discountObjects.map((discount, i) => discount.id)} />
            </Card>
        </Paper>
    </Stack>;
}

const SalesRepCommissionsView = () => {
    let params = useParams();
    const user = useSelector(state => state.auth.user)

    const {data: object, error, isLoading } = useGetSalesRepQuery(user.rep_id)
    const {data: discounts, error: discountsError, isLoading: isLoadingDiscounts} = useGetSalesRepDiscountsQuery(user.rep_id)
    const {data: contracts, error: contractsError, isLoading: isLoadingContracts} = useGetSalesRepContractsQuery(user.rep_id)

    const [updateObject, {isLoadingUpdate: isUpdating }] = useUpdateSalesRepMutation();

    if(!user.rep_id) {
        return <Navigate to="/salesreps" />
    }

    if (isLoading || isUpdating || isLoadingDiscounts || isLoadingContracts) {
      return <Loading />;
    }
    if (error || discountsError || contractsError) {
      return <div>Error: {error.error}</div>
    }

    var discountObjects = []
    if (discounts) {
        discountObjects = discounts.objects;
    }
    var contractObjects = []
    var contract = <Typography variant='p'>No active contract</Typography>
    if (contracts) {
        contractObjects = contracts.objects.slice().filter((c) => dayjs().isBetween(dayjs.utc(c.startdate).local(), dayjs.utc(c.enddate).local(), null, "[]")).sort((a, b) => a.commission > b.commission);
        if(contractObjects.length > 0) {
            let bestContract = contractObjects[0]
            contract = <ViewContractCard key={bestContract.id} object={bestContract} />
        }
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <Paper>
            <Card>
                <Stack direction="column" sx={{margin: 2}} spacing={2}>
                    <Typography variant='h2'>{object.name}</Typography>
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Customer codes</Typography>
                {
                    discountObjects.map((discount, i) => <DiscountCard key={discount.id} discount={discount} admin={false} />)
                }
                <Typography variant='p'><b>Distributor registration link:</b> <Link href={`https://leftcoastcabinets.com/distributor?ref=${user.rep_id}`}>https://leftcoastcabinets.com/distributor?ref={user.rep_id}</Link></Typography>
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
            <Stack direction="column" sx={{margin: 2}} spacing={2}>
                <Typography variant='h2'>Current contract</Typography>
                    {contract}
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <SalesRepOrdersListView contracts={contractObjects} salesrep={object} discounts={discountObjects.map((discount, i) => discount.id)} />
            </Card>
        </Paper>
        <Paper>
            <Card>
                <SalesRepFindersListView salesrep={object} contracts={contractObjects} />
            </Card>
        </Paper>
    </Stack>;
}

const CommissionsView = () => {
    const user = useSelector(state => state.auth.user)
    if (user.type === "rep") {
        return <SalesRepCommissionsView />;
    }
    return <DistributorCommissionsView />;
}

export default CommissionsView;
